/**
 * Created by Sina Khelil on 6/3/15.
 */
require('./lib/dropdown');

module.export = angular.module('ui-ng-dropdown', ['ngDropdowns']);



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-dropdown/src/main.js